"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isRTL = function isRTL(props) {
  return false;
};
var reverseTransform = "scale(-1, 1)";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return _react2.default.createElement(
    "svg",
    Object.assign({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      transform: isRTL(props) ? reverseTransform : null,
      ref: svgRef
    }, props),
    _react2.default.createElement("path", {
      d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2.323A9.672 9.672 0 002.323 12a9.648 9.648 0 002.89 6.901c2.826-2.126 4.239-3.336 4.239-3.633 0-.467 1.191-1.121 0-2.103-1.192-.983-3.623-8.35 2.686-8.35s4.106 7.031 3.009 8.35c-1.097 1.318.077 2.089.628 2.72.32.365 1.432 1.257 3.339 2.676A9.63 9.63 0 0021.677 12c0-5.35-4.329-9.677-9.677-9.677z",
      fill: "#5B5E65",
      fillRule: "evenodd"
    })
  );
};

var ForwardRef = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(SvgUser, Object.assign({ svgRef: ref }, props));
});
exports.default = ForwardRef;